const clearPropertyReferenceStorage = () => {
  const propertyReference = window.localStorage.getItem('propertyReference')
  if (propertyReference) window.localStorage.removeItem('propertyReference')
}

export default clearPropertyReferenceStorage
